import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  title: {
    [theme.breakpoints.up('viewportMedium')]: {
      marginTop: '1.25rem',
    },
  },
  tab_vehicle_year: {
    '&:last-child': {
      '&>.divider': {
        '&:before': {
          backgroundColor: colors.black,
          content: "''",
          display: 'inline-block',
          height: '0.875rem',
          marginLeft: '0.75rem',
          position: 'relative',
          width: '0.0625rem',
          top: '0.125rem',
        },
      },
    },
  },
  select_vehicle_year: {
    lineHeight: '1.25rem',
    letterSpacing: 'normal',
    padding: '0',
    justifyContent: 'flex-start',
    margin: '0.3125rem 0 0.3125rem 0.75rem',
    textTransform: 'none',
    color: colors.acura_red,
    cursor: 'pointer',
    '&:hover': {
      background: 'transparent',
    },
  },
  vehicle_year_tab: {
    color: colors.acura_red,
    '&.selected': {
      color: colors.black,
      cursor: 'default',
    },
  },
  button_container: {
    margin: '0.3125rem 0',
    marginBottom: '1.25rem',
    '&.disabled': {
      opacity: '.5',
    },
  },
  form_control: {
    position: 'relative',
    minWidth: 120,
    marginBottom: '1.875rem !important',
    width: '100%',
    maxWidth: '22.5rem',
    backgroundColor: 'white',
    [theme.breakpoints.up('viewportMedium')]: {
      maxWidth: '18.75rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '21.25rem',
    },
    '&.disabled': {
      opacity: '.5',
    },
  },
  supply_message: {
    maxWidth: '22.5rem',
    marginTop: '0.625rem',
    marginBottom: '1.0625rem',
    color: colors.mid_grey,
    [theme.breakpoints.up('viewportMedium')]: {
      maxWidth: '18.75rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '21.25rem',
    },
  },
  vehicle_card_container: {
    marginTop: '1.25rem',
    marginBottom: '3.875rem',
    [theme.breakpoints.up('viewportMedium')]: {
      marginTop: '0',
    },
  },
  error_tag: {
    color: colors.acura_red,
    marginLeft: '1.25rem',
    marginTop: '0.3125rem',
    [theme.breakpoints.up('viewportMedium')]: {
      marginTop: '0.625rem',
    },
  },
});
